export default "/images/92a0a9f3933adeedbc0f62a762154f3c.avif";